import React from 'react';
import styled from 'styled-components';

import * as Common from '../../Styles';

const Theme = Common.Theme;

export const Dialog = styled(Common.Dialog)``;

export const DialogActions = styled(Common.DialogActions)``;

export const DialogTitle = styled(Common.DialogTitle)``;

export const DialogContent = styled(Common.DialogContent)``;

export const InputGroup = styled(Common.InputGroup)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Button = styled(Common.Button)``;

export const ButtonWithLoader = styled(Common.ButtonWithLoader)``;

export const CircularButton = styled(Common.CircularButton)``;

export const FlexRow = styled(Common.FlexRow)``;

export const CheckboxGroup = styled(Common.CheckboxGroup)``;
